import { styled } from '@mui/material';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';

const HeroSection = styled('section')(({ theme }) => ({
  background: 'url("https://bucket.ywhdev.com/wl/?id=rrED4XAjdYJJcaPwHBlpCp37wdDcnzFh&fmode=open")',
  overflow: 'hidden',
  height: 700,
  [theme.breakpoints.down('sm')]: {
    height: 450,
  },
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 80,
  position: 'relative',
  backgroundPosition: 'top center',
  backgroundSize: 'cover',
  borderBottom: '8px solid #5284e0',
  gap: 8,
  textAlign: 'center',
  [theme.breakpoints.down('lg')]: {
    backgroundPosition: 'center',
  },
  '& div.header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    h1: {
      color: 'white',
      fontFamily: 'Playfair Display',
      zIndex: 2,
      fontSize: 48,
      lineHeight: '60px',
      fontWeight: 700,
    },
    h3: {
      color: '#CDA07D',
      zIndex: 2,
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 600,
    },
  },
}));

const Content = styled('section')(({ theme }) => ({
  paddingTop: 100,
  [theme.breakpoints.down('sm')]: {
    paddingTop: '1rem',
  },
}));

const CustomHomes = () => {
  return (
    <>
      <HeroSection>
        <div className="header">
          <h1>
            Your Vision.
            <br />
            Our Craftsmanship.
          </h1>
          <h3>View the steps we'll take to build your custom dream home</h3>
        </div>
      </HeroSection>
      <Content>
        <Section1 />
        <Section2 />
        <Section3 />
        <Section4 />
      </Content>
    </>
  );
};

export default CustomHomes;
